import type Animations from '@lved/ui/components/shared/ui/Tabs/Animations';
import { ReactWidget } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';

type AnimationsModule = { Animations: typeof Animations };

@injectable()
export class AnimationsPanel extends ReactWidget {
    static readonly ID: string = 'widget:lvgl-animations';
    static readonly LABEL: string = 'Animations';

    protected module: AnimationsModule | undefined;
    protected loadError: string | undefined;

    @postConstruct()
    protected init(): void {
        this.doInit();
    }

    protected async doInit(): Promise<void> {
        this.id = AnimationsPanel.ID;
        this.title.label = AnimationsPanel.LABEL;
        this.title.caption = AnimationsPanel.LABEL;
        this.title.closable = true;
        await this.loadModule();
        this.update();
    }

    protected async loadModule(): Promise<void> {
        try {
            this.module = (await import('@lved/ui')) as unknown as AnimationsModule;
        } catch (error: unknown) {
            this.loadError = error instanceof Error ? error.message : 'Failed to load Animations panel.';
        }
    }

    protected render(): JSX.Element {
        if (this.loadError) return <p>{this.loadError}</p>;
        if (!this.module) return <p>Loading Animations...</p>;
        const { Animations } = this.module;
        return <Animations />;
    }
}
